import * as React from 'react';
import { History } from 'history';
import Model from './quizquestion-model';
import BaseList from '../base/base-list.component';

interface IProps {  
  history: History;
  root?: string;
  caption?: string;
  sectionId?: number;
  actions?: any;
  disableBackButton?: boolean;
  disableCard?: boolean;
  onLoad?: (data: any) => void;
  
}

interface IState {
}

export default class QuizquestionList extends React.Component<IProps, IState> {
  
  constructor(props: IProps) {
    super(props);
  }
  
  public render(): React.ReactNode {
    return (
      <BaseList history={this.props.history} parentId={this.props.sectionId} caption={this.props.caption} endPointFilter={Model.endPointFilter+this.props.sectionId} url={(this.props.root || '') + Model.url} model={Model} actions={this.props.actions} disableBackButton={this.props.disableBackButton} disableCard={this.props.disableCard}/>
    );
  }
}
